import merge from 'lodash.merge';
import { ANWBBrandRefreshTheme } from './anwb-brand-refresh-theme';
import { ANWBDefaultThemeCurrent } from './current';
import { ANWBDefaultThemeV9 } from './v9';
import { ANWBDefaultThemeV10 } from './v10';
export const ANWBDefaultTheme = merge({}, // fix reference issue
ANWBBrandRefreshTheme, // support Brand Refresh only token in default theme
ANWBDefaultThemeV9, ANWBDefaultThemeV10, ANWBDefaultThemeCurrent);
//# sourceMappingURL=anwb-default-theme.js.map